exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ButtonContainer__ProductInvoice-module___1JQNc {\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.entryNumber__ProductInvoice-module___1iTDH {\n  margin: 10px;\n}\n\n@media (max-width: 768px) {\n  .ledgersContainer__ProductInvoice-module___3nFLq {\n    margin-top: 12px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"ButtonContainer": "ButtonContainer__ProductInvoice-module___1JQNc",
	"entryNumber": "entryNumber__ProductInvoice-module___1iTDH",
	"ledgersContainer": "ledgersContainer__ProductInvoice-module___3nFLq"
};